// About.js

import React from "react";

import {
  ShieldCheck,
  Landmark,
  Smartphone,
  Globe2,
  TrendingUp,
  Users,
  BadgeDollarSign,
  CircleCheckBig,
} from "lucide-react";

import "../Styles/about.css";

const About = () => {

  return (
    <div className="modern-about-page">

      {/* HERO */}
      <section className="modern-about-hero">

        <div className="modern-about-overlay" />

        <div className="modern-about-content">

          <div className="modern-about-badge">
            ABOUT RCS
          </div>

          <h1 className="modern-about-heading">
            Built On Trust.
            <br />
            <span>Powered By Service.</span>
          </h1>

          <p className="modern-about-text">
            Delivering reliable digital, financial
            and payment solutions throughout
            Wakenaam and across Guyana.
          </p>

        </div>

      </section>

      {/* WHO WE ARE */}
      <section className="modern-about-section">

        <div className="modern-about-card">

          <div className="modern-about-icon">
            <Users size={36} />
          </div>

          <div>

            <h2>
              Who We Are
            </h2>

            <p>
              RCS Top-Up & Billing Entity is a
              multi-service business based in
              Wakenaam, Essequibo. We proudly
              serve our community by offering
              a wide range of digital and
              financial solutions all in one
              location.
            </p>

            <p>
              With our ever-growing line of
              services, we continue to provide
              convenience, reliability and
              accessibility to customers,
              businesses and investors.
            </p>

          </div>

        </div>

      </section>

      {/* SERVICES */}
      <section className="modern-services-highlight">

        <h2>
          What We Do
        </h2>

        <div className="modern-services-grid-about">

          <div className="modern-service-box">
            <Smartphone size={32} />
            <h3>Mobile Services</h3>
            <p>
              Wholesale & retail top-up
              and phone card solutions
              for Digicel, One
              Communications and Enet.
            </p>
          </div>

          <div className="modern-service-box">
            <BadgeDollarSign size={32} />
            <h3>MMG+ Services</h3>
            <p>
              Wakenaam’s only MMG+
              Superagent and Distributor,
              offering trusted digital
              transaction services.
            </p>
          </div>

          <div className="modern-service-box">
            <Globe2 size={32} />
            <h3>Money Transfers</h3>
            <p>
              Local and international
              MoneyGram services and
              payment solutions for the
              public and senior citizens.
            </p>
          </div>

          <div className="modern-service-box">
            <Landmark size={32} />
            <h3>Financial Solutions</h3>
            <p>
              Ferry bookings, bill
              payments, investment
              opportunities and business
              financing services.
            </p>
          </div>

        </div>

      </section>

      {/* COMMITMENT */}
      <section className="modern-commitment-section">

        <div className="commitment-card">

          <div className="commitment-left">

            <div className="modern-about-icon green">
              <ShieldCheck size={40} />
            </div>

            <h2>
              Our Commitment
            </h2>

            <p>
              We value reliability,
              professionalism and community.
              Every interaction is designed
              to be secure, efficient and
              customer-focused.
            </p>

          </div>

          <div className="commitment-right">

            <div className="commitment-item">
              <CircleCheckBig size={20} />
              Trusted Customer Service
            </div>

            <div className="commitment-item">
              <CircleCheckBig size={20} />
              Secure Transactions
            </div>

            <div className="commitment-item">
              <CircleCheckBig size={20} />
              Community Driven
            </div>

            <div className="commitment-item">
              <CircleCheckBig size={20} />
              Innovative Financial Solutions
            </div>

          </div>

        </div>

      </section>


{/* ANNIVERSARY */}

<section className="modern-anniversary-section">

  <div className="modern-anniversary-card">

    <div className="anniversary-glow" />

    <div className="anniversary-left">

      <div className="anniversary-badge">
        CELEBRATING A MILESTONE
      </div>

      <h2>
        RCS Turns
        <span> 5 Years</span>
      </h2>

      <h3>
        August 24th, 2026
      </h3>

      <p>
        This milestone would never have
        been possible without the support,
        trust and loyalty of our valued
        customers, agents, partners,
        investors and stakeholders.
      </p>

      <p>
        Over the past five years, RCS has
        grown into a trusted name for
        financial, payment and business
        solutions throughout Wakenaam
        and across Guyana.
      </p>

      <div className="anniversary-thanks">
        Thank You For Being Part Of
        The RCS Journey.
      </div>

    </div>

    <div className="anniversary-right">

      <div className="anniversary-number">
        5
      </div>

      <div className="anniversary-years">
        YEARS
      </div>

    </div>

  </div>

</section>




      {/* STATS */}
      <section className="modern-about-stats">

        <div className="about-stat-box">
          <h2>10+</h2>
          <p>Financial Services</p>
        </div>

        <div className="about-stat-box">
          <h2>60,000+</h2>
          <p>Recorded transactions</p>
        </div>

        <div className="about-stat-box">
          <h2>24/7</h2>
          <p>Customer Commitment</p>
        </div>

        <div className="about-stat-box">
          <h2>1</h2>
          <p>Trusted RCS Experience</p>
        </div>

      </section>

    </div>
  );
};

export default About;